import React, { useEffect } from 'react';
import styled from 'styled-components';
import isMobile from 'helpers/isMobile';
import logoSpinner from 'images/lottie/CC_Logo_Load.lottie';
import { Text } from '@companycam/slab-web';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { translate } from 'javascripts/translations/i18n';

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinnerAnim = styled(DotLottieReact)`
  margin: 32px;
  width: 160px;
`;

const LoadingSpinner = ({ redirect }: { redirect: string }) => {
  useEffect(() => {
    // Wait arbitrary amount of time for complete registration event to finish
    if (!isMobile) {
      setTimeout(() => {
        window.Turbo.visit(redirect);
      }, 5000);
    }
  }, [redirect]);

  return (
    <LoadingWrapper>
      <LoadingSpinnerAnim
        src={logoSpinner}
        autoplay
        loop
        renderConfig={{ freezeOnOffscreen: false, autoResize: false }}
      />
      <Text as="p" size="m" weight="700" family="heading">
        {translate('onboard.loading.message')}
      </Text>
    </LoadingWrapper>
  );
};

export default LoadingSpinner;
